module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/saving-mobile-phone.12d44b1b.png";